import { render, staticRenderFns } from "./TeacherClasses.vue?vue&type=template&id=40c629e7"
import script from "./TeacherClasses.vue?vue&type=script&lang=js"
export * from "./TeacherClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports